import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeFormFieldModule } from 'se-fe-form-field'
import { SeFeFormFieldTextModule } from 'se-fe-form-field-text'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedFeatureOrganizationListModule } from '../lib/shared-feature-organization-list.module'
import { OrganizationListDocsComponent } from './organization-list-docs/organization-list-docs.component'
import { OrganizationListExampleComponent } from './organization-list-docs/organization-list-example.component'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeFormFieldModule,
    SeFeFormFieldTextModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedFeatureOrganizationListModule
  ],
  declarations: [
    OrganizationListDocsComponent,
    OrganizationListExampleComponent
  ],
  exports: [
    OrganizationListDocsComponent
  ]
})
export class SharedFeatureOrganizationListDocsModule {}
